import { render, staticRenderFns } from "./EmployeesFoldersMediaAdd.vue?vue&type=template&id=6128a608&"
import script from "./EmployeesFoldersMediaAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeesFoldersMediaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports